export const CHAINSELECTOR_LIST = 'CHAINSELECTOR_LIST';
export const CHAINSELECTOR_LIST_SUCCESS = 'CHAINSELECTOR_LIST_SUCCESS';
export const CHAINSELECTOR_LIST_ERROR = 'CHAINSELECTOR_LIST_ERROR';

export const ADD_CHAINSELECTOR_LIST = 'ADD_CHAINSELECTOR_LIST';
export const ADD_CHAINSELECTOR_LIST_SUCCESS = 'ADD_CHAINSELECTOR_LIST_SUCCESS';
export const ADD_CHAINSELECTOR_LIST_ERROR = 'ADD_CHAINSELECTOR_LIST_ERROR';

export const CHAINSELECTOR_LIST_DETAILS = 'CHAINSELECTOR_LIST_DETAILS';
export const CHAINSELECTOR_LIST_DETAILS_SUCCESS = 'CHAINSELECTOR_LIST_DETAILS_SUCCESS';
export const CHAINSELECTOR_LIST_DETAILS_ERROR = 'CHAINSELECTOR_LIST_DETAILS_ERROR';

export const CHAINSELECTOR_LIST_UPDATE = 'CHAINSELECTOR_LIST_UPDATE';
export const CHAINSELECTOR_LIST_UPDATE_SUCCESS = 'CHAINSELECTOR_LIST_UPDATE_SUCCESS';
export const CHAINSELECTOR_LIST_UPDATE_ERROR = 'CHAINSELECTOR_LIST_UPDATE_ERROR';

export const DELETE_CHAINSELECTOR_LIST = 'DELETE_CHAINSELECTOR_LIST';
export const DELETE_CHAINSELECTOR_LIST_ERROR = 'DELETE_CHAINSELECTOR_LIST_ERROR';
export const DELETE_CHAINSELECTOR_LIST_SUCCESS = 'DELETE_CHAINSELECTOR_LIST_SUCCESS';